__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "OrgDetailsMfe";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common", "12.2.17", () => (() => (__webpack_require__(/*! ./node_modules/@angular/common/fesm2015/common.js */ 16897))), 1);
			register("@angular/core", "12.2.17", () => (() => (__webpack_require__(/*! ./node_modules/@angular/core/fesm2015/core.js */ 85861))), 1);
			register("@angular/router", "12.2.17", () => (() => (__webpack_require__(/*! ./node_modules/@angular/router/fesm2015/router.js */ 57649))), 1);
			register("@lst/lst-auth", "2.0.6", () => (() => (__webpack_require__(/*! ./node_modules/@lst/lst-auth/fesm2015/lst-lst-auth.js */ 70932))), 1);
			register("apollo-angular", "2.6.0", () => (() => (__webpack_require__(/*! ./node_modules/apollo-angular/fesm2015/ngApollo.js */ 99034))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};